// Ephemeral completion events only. No prompt text, ratings, or sentiment.
const listeners = new Set();
const interactionListeners = new Set();

export function subscribeReviewInteractions(listener) {
  interactionListeners.add(listener);
  return () => interactionListeners.delete(listener);
}

export function notifyReviewInteraction() {
  interactionListeners.forEach(listener => listener());
}

export function subscribeReviewActivity(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyReviewActivity(conversationId, data) {
  const reply = data?.find(item => {
    const message = item?.message;
    return message?.role?.toLowerCase?.() === 'assistant'
      && !message.isError && !message.hasError && !message.error && !message.flags?.isError
      && (message.content || message.images?.length || message.files?.length);
  })?.message;
  const id = reply?._id || reply?.id;
  if (!conversationId || !id) return;
  listeners.forEach(listener => {
    try {
      Promise.resolve(listener({ conversationId: String(conversationId), completionId: String(id) })).catch(() => {});
    }
    catch (_) { /* Review requests must never interfere with a chat. */ }
  });
}
